import { Row, Separator } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { usePageTitle } from '../../app/PageTitleContext'
import DeleteGroupMembersButton from './DeleteGroupMembersButton'
import DemotePromoteMembersButton from './DemotePromoteMembersButton'
import DownloadGroupMembersButton from './DownloadGroupMembersButton'
import GroupMembersList from './GroupMembersList'
import useGroupMembers from './useGroupMembers'
import { PermissionsContext } from '../../app/PermissionsContext'

export default function GroupMembers() {
  usePageView({ page_detail: 'DMConsole:GroupMembers' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.group.members'))
  const { isAuthorized } = useContext(PermissionsContext)
  const [groupMembersState, helpers] = useGroupMembers()
  const atLeastOneMemberSelected = groupMembersState.selectedMembers.length > 0

  return (
    <>
      {groupMembersState.members && (
        <>
          {groupMembersState.members.length > 0 ? (
            <>
              <Row>
                <DownloadGroupMembersButton members={groupMembersState.members} />
                {isAuthorized('ModifyDataPermission') && (
                  <Row>
                    <DemotePromoteMembersButton
                      members={groupMembersState.selectedMembers}
                      refreshData={helpers.refreshData}
                      show={atLeastOneMemberSelected}
                    />
                    <DeleteGroupMembersButton
                      members={groupMembersState.selectedMembers}
                      refreshData={helpers.refreshData}
                      show={atLeastOneMemberSelected}
                    />
                  </Row>
                )}
              </Row>
              <Separator size="nano" />
              <GroupMembersList
                groupMembersState={groupMembersState}
                setCheckedMembers={helpers.setCheckedMembers}
                refreshData={helpers.refreshData}
              />
            </>
          ) : (
            t('group.members.notFound', 'No members found.')
          )}
        </>
      )}
    </>
  )
}
